define( 'Accordions',[ 'jquery', 'ANSI/Utility/SitecoreUtils', 'eventManager', 'promise-polyfill' ], function ( $, sitecoreUtils, eventManager ) {
    'use strict';
    var accordion = {
        init: function () {
            var $coveoResultList = $('.CoveoResultList');
            if ($coveoResultList.length > 0) {
                accordion.collapseAccordionForSearch($coveoResultList);
            }
            var $accordions = $('.score-accordion');
            var accordionsLength = $accordions.length;
            if (accordionsLength > 0) {
                for (var i = 0; i < accordionsLength; i++) {
                    var currentAccordion = $accordions.get(i);
                    var $currentAccordion = $(currentAccordion);
                    accordion.initCommon($currentAccordion);
                    accordion.addMatchId($currentAccordion);
                    if (currentAccordion.classList.contains('ansi-read-more')
                        || currentAccordion.classList.contains('load-more')) {
                        accordion.collapseAccordion($currentAccordion);
                    } else {
                        accordion.addActive($currentAccordion);
                    }
                }
                if ( $('.ansi-sticky-navbar').length > 0 ) {
                    accordion.scrollToPanel();
                    accordion.activeOnClick();
                }
            }
        },
        collapseAccordion: function ($currentAccordion) {
            $currentAccordion.find('.score-accordion-panel:first-of-type').removeClass( 'active' );
            eventManager.subscribe('ModulesLoadedEvent', function () {
                $currentAccordion.find('.panel-collapse').removeClass('in').addClass('collapse').attr('aria-expanded', 'false');
                $currentAccordion.find('.panel-title a').attr( 'aria-expanded', 'false' );
            } );
        },
        collapseAccordionForSearch: function ($coveoResultList) {
            eventManager.subscribe('SearchResultsLoadedEvent', function () {
                var $accordions = $coveoResultList.find('.score-accordion');
                var accordionsLength = $accordions.length;
                if (accordionsLength > 0) {
                    for (var i = 0; i < accordionsLength; i++) {
                        var currentAccordion = $accordions.get(i);
                        var $currentAccordion = $(currentAccordion);
                        $currentAccordion.find('.score-accordion-panel').removeClass('panel');
                        $currentAccordion.find('.panel-collapse').removeClass('in').addClass('collapse').attr('aria-expanded', 'false');
                        $currentAccordion.find('.panel-title a').attr('aria-expanded', 'false');
                    }
                }
            });
        },
        addActive: function ($currentAccordion) {
            var $firstNotCollapsed = $currentAccordion.find('.score-accordion-panel:first-of-type').not('.collapsed .score-accordion-panel');
            if ($firstNotCollapsed.length > 0) {
                $firstNotCollapsed.addClass('active');
                $firstNotCollapsed.find('.panel-collapse').removeClass('collapse').addClass('in').attr('aria-expanded', 'true');
                $firstNotCollapsed.find('.panel-title a').attr('aria-expanded', 'true').removeClass('collapsed');
            }
        },
        initCommon: function ($currentAccordion) {
            $currentAccordion.find('.score-accordion-panel').removeClass('panel');
            //Remove active state from accordions with component property set to be collapsed on load
            $currentAccordion.find('.collapsed .score-accordion-panel').removeClass('active');
            $('.panel-collapse', $currentAccordion).on('shown.bs.collapse', function (e) {
                $(this).closest('.score-accordion-panel').addClass('active');
            });
            $('.panel-collapse', $currentAccordion).on('hidden.bs.collapse', function (e) {
                $(this).closest('.score-accordion-panel').removeClass('active');
            });
            $('.panel-body').on("click", function (e) {
                e.stopPropagation();
            });
        },
        addMatchId: function ($currentAccordion) {
            $currentAccordion.find( '.panel-group .score-accordion-panel' ).each( function ( i ) {
                var upOne = i + 1;
                $( this ).attr( 'id', 'panel' + upOne );
            } );
        },
        scrollToPanel: function () {
            $( '.score-button-menu li:nth-child(1) > a' ).addClass( 'active' );
            var scrollButton = $( '.ansi-sticky-navbar .score-button-menu  a:not( .score-button-menu-item.sticky-nav-modal-btn  a)' );
            $( '.modal.fade' ).on( 'shown.bs.modal', function () {
                $( '.score-modal' ).appendTo( 'body' );
            } );
            scrollButton.on("click", function ( e ) {
                e.preventDefault();

                $( '.score-button-menu li a' ).removeClass( 'active' );
                $( this ).addClass( 'active' );
                $( '.panel-collapse' ).collapse( 'hide' );
                var elem = $( this );
                //Check to see if button has href
                var match = elem.attr( 'href' );

                if ( match == null ) {
                    return;
                }
                var index = match.indexOf( '#' );
                if ( index > -1 && index < match.length - 1 ) {
                    //check to see that it is not just a #
                    var matchedId = match.substring( index + 1, match.length );
                    var foundMatches = $( '.score-accordion-panel' );
                    var self;

                    foundMatches.each( function ( index ) {
                        if ( $( this ).attr( 'id' ) === matchedId ) {
                            self = $( this );
                            $( this ).find( '.panel-collapse' ).collapse( 'show' );
                            setTimeout( function () {
                                scrollToView();
                            }, 600 )
                        }
                    } );
                }

                var scrollToView = function scrollToView() {
                    window.scroll( {
                        top: ( $( elem.attr( 'href' ) ).offset().top ) - 80,
                        behavior: 'smooth'
                    } )
                }
            } );
        },
        activeOnClick: function () {
            $( '.score-accordion-panel' ).on("click", function ( e ) {
                var activePanel = $( this ).attr( 'id' );
                var panelID = '#' + activePanel;
                var self = $( this );
                setTimeout( function () {
                    window.scroll( {
                        top: ( self.offset().top ) - 80,
                        behavior: 'smooth'
                    } )
                }, 600 );

                $( '.ansi-sticky-navbar .score-button-menu  a' ).each( function ( item ) {
                    var ref = $( this ).attr( 'href' );
                    if ( ref === panelID ) {
                        $( '.panel-collapse' ).collapse( 'hide' );
                        $( '.score-button-menu li a' ).removeClass( 'active' );
                        $( this ).addClass( 'active' );
                    }
                } );
            } );
        }
    };
    if ( !sitecoreUtils.prototype.isEditing() ) Promise.resolve().then( accordion.init );
});
